module.exports = __webpack_public_path__ + "a648d39d1b3793b19b4615454e2c1ed7.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-banner-sleep.svg
// module id = 471
// module chunks = 0